import React from 'react';

import { ConfirmModal } from '~/components/ConfirmModal';

type IncidentTypeEditConfirmDialogProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const IncidentTypeEditConfirmDialog = ({ isOpen, onCancel, onConfirm }: IncidentTypeEditConfirmDialogProps) => {
  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Change the incident type?"
      contentText="Changing the incident type or sub type of the claim may change additional data of it. If you choose to proceed, please review the involved parties, the additional claim data and the exposures, and update as applicable."
      primaryButtonName="CHANGE"
      onClose={onCancel}
      onPrimaryBtnClick={onConfirm}
    />
  );
};

export default IncidentTypeEditConfirmDialog;
